/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSidebarSellerInfo_viewer$ref = any;
export type PdpRespSidebarSellerInfo_viewer = {
    readonly isReviewsEnabled: boolean | null;
    readonly " $refType": PdpRespSidebarSellerInfo_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarSellerInfo_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isReviewsEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "ORDER_FEEDBACK"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
        }
    ]
} as any);
(node as any).hash = '321cdfee61404af5e789b9c50e2fb7fd';
export default node;
